(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eloi-coco-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initEloiCocoHero = (root = document) => {
      const sections = root.querySelectorAll('[data-eloi-coco-hero]');

      sections.forEach((section) => {
        const items = section.querySelectorAll('.eloi-coco-reveal:not([data-eloi-observed])');

        if (!items.length) {
          return;
        }

        if (!('IntersectionObserver' in window)) {
          items.forEach((item) => {
            item.classList.add('is-visible');
            item.dataset.eloiObserved = 'true';
          });
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.18 }
        );

        items.forEach((item) => {
          item.dataset.eloiObserved = 'true';
          observer.observe(item);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initEloiCocoHero());
    } else {
      initEloiCocoHero();
    }

    document.addEventListener('shopify:section:load', (event) => initEloiCocoHero(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloi-fragrance-footer"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   ELOI FRAGRANCE FOOTER — perilaku
   Ditulis tanpa Liquid supaya bisa dibundel sekali oleh Shopify. Tiap footer di-init sendiri, dan ikut di-init ulang/dibersihkan
   saat section dimuat ulang di Theme Editor.
   ============================================================================ */
(function () {
  'use strict';

  var registry = new WeakMap();
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 861px)');

  function init(footer) {
    if (!footer || registry.has(footer)) return;

    var cleanups = [];
    registry.set(footer, cleanups);

    function on(el, type, fn, opts) {
      el.addEventListener(type, fn, opts);
      cleanups.push(function () { el.removeEventListener(type, fn, opts); });
    }

    footer.classList.add('ef-js');

    /* ---------- accordion kolom (mobile) ---------- */
    footer.querySelectorAll('.ef-toggle').forEach(function (btn) {
      on(btn, 'click', function () {
        var col = btn.closest('.ef-column');
        if (!col) return;
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- chip aroma ----------
       hover/focus = pratinjau, klik/tap = kunci pilihan.
       Versi lama cuma pakai pointerenter, jadi di HP chip-nya tidak bisa dipakai. */
    var readout = footer.querySelector('[data-ef-note-readout]');
    var defaultText = readout ? readout.textContent : '';
    var pinned = null;

    function setNote(text) {
      if (!readout || readout.textContent === text) return;
      readout.textContent = text;
      if (!reduce.matches && readout.animate) {
        readout.animate(
          [{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 280, easing: 'ease-out' }
        );
      }
    }
    function restingText() {
      return pinned ? (pinned.getAttribute('data-note') || defaultText) : defaultText;
    }

    footer.querySelectorAll('.ef-note-chip').forEach(function (chip) {
      var note = chip.getAttribute('data-note') || '';
      var preview = function () { if (note) setNote(note); };
      var restore = function () { setNote(restingText()); };

      on(chip, 'pointerenter', preview);
      on(chip, 'focus', preview);
      on(chip, 'pointerleave', restore);
      on(chip, 'blur', restore);
      on(chip, 'click', function () {
        if (pinned === chip) {
          chip.classList.remove('is-active');
          chip.setAttribute('aria-pressed', 'false');
          pinned = null;
          setNote(defaultText);
          return;
        }
        if (pinned) {
          pinned.classList.remove('is-active');
          pinned.setAttribute('aria-pressed', 'false');
        }
        pinned = chip;
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        if (note) setNote(note);
      });
    });

    /* ---------- efek magnetik (hanya mouse, hanya desktop) ---------- */
    footer.querySelectorAll('.magnetic').forEach(function (el) {
      on(el, 'pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !desktop.matches || reduce.matches) return;
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.14;
        var y = (e.clientY - r.top - r.height / 2) * 0.14;
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      on(el, 'pointerleave', function () { el.style.transform = ''; });
    });

    /* ---------- tombol kembali ke atas ---------- */
    var topBtn = footer.querySelector('[data-ef-top]');
    if (topBtn) {
      on(topBtn, 'click', function () {
        window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
      });
      var toggleTop = function () { topBtn.classList.toggle('is-visible', window.scrollY > 260); };
      on(window, 'scroll', toggleTop, { passive: true });
      toggleTop();
    }

    /* ---------- kanvas partikel ----------
       Versi lama: warna pink hardcoded, setting opasitas tidak dipakai, dan
       loop jalan terus walau footer tidak terlihat (O(n^2) tiap frame).
       Sekarang: warna ikut --ef-text, opasitas ikut setting, dan berhenti
       saat footer di luar layar atau tab tidak aktif. */
    var canvas = footer.querySelector('[data-ef-canvas]');
    var ctx = null, raf = 0, w = 0, h = 0, parts = [], visible = false;
    var color = '#ffffff', pAlpha = 0.25, count = 0;
    var LINK = 96;

    function sizeCanvas() {
      var rect = footer.getBoundingClientRect();
      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      var nw = Math.max(1, Math.floor(rect.width));
      var nh = Math.max(1, Math.floor(rect.height));
      var reseed = !parts.length || Math.abs(nw - w) > 40;
      w = nw; h = nh;
      canvas.width = Math.floor(w * ratio);
      canvas.height = Math.floor(h * ratio);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      if (reseed) seed();
    }

    function seed() {
      parts = [];
      for (var i = 0; i < count; i++) {
        parts.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 1.5 + 0.4,
          vx: (Math.random() - 0.5) * 0.16,
          vy: (Math.random() - 0.5) * 0.16,
          a: Math.random() * 0.8 + 0.2
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = color;
      ctx.strokeStyle = color;
      ctx.lineWidth = 1;

      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.x += p.vx; p.y += p.vy;
        if (p.x < -10) p.x = w + 10; else if (p.x > w + 10) p.x = -10;
        if (p.y < -10) p.y = h + 10; else if (p.y > h + 10) p.y = -10;

        ctx.globalAlpha = p.a * pAlpha;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();

        for (var j = i + 1; j < parts.length; j++) {
          var q = parts[j];
          var dx = p.x - q.x, dy = p.y - q.y;
          var d2 = dx * dx + dy * dy;
          if (d2 < LINK * LINK) {
            ctx.globalAlpha = (1 - Math.sqrt(d2) / LINK) * 0.35 * pAlpha;
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(q.x, q.y);
            ctx.stroke();
          }
        }
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(draw);
    }

    function startCanvas() {
      if (!ctx || raf || reduce.matches || document.hidden || !visible) return;
      raf = requestAnimationFrame(draw);
    }
    function stopCanvas() {
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
    }

    if (canvas && canvas.getContext && !reduce.matches) {
      ctx = canvas.getContext('2d');
      var cs = getComputedStyle(footer);
      color = (cs.getPropertyValue('--ef-text') || '').trim() || '#ffffff';
      pAlpha = parseFloat(cs.getPropertyValue('--ef-particle-opacity'));
      if (!isFinite(pAlpha)) pAlpha = 0.25;
      count = parseInt(footer.getAttribute('data-particles'), 10);
      if (!isFinite(count) || count < 0) count = 28;

      sizeCanvas();

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function () { sizeCanvas(); });
        ro.observe(footer);
        cleanups.push(function () { ro.disconnect(); });
      } else {
        on(window, 'resize', sizeCanvas);
      }
      on(document, 'visibilitychange', function () {
        document.hidden ? stopCanvas() : startCanvas();
      });
      cleanups.push(stopCanvas);
    }

    /* ---------- masuk layar: isi bar notes + nyalakan kanvas ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) {
            footer.classList.add('is-inview');
            startCanvas();
          } else {
            stopCanvas();
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      io.observe(footer);
      cleanups.push(function () { io.disconnect(); });
    } else {
      visible = true;
      footer.classList.add('is-inview');
      startCanvas();
    }
  }

  function destroy(footer) {
    var list = registry.get(footer);
    if (!list) return;
    list.forEach(function (fn) { try { fn(); } catch (e) {} });
    registry.delete(footer);
    footer.classList.remove('ef-js', 'is-inview');
  }

  function initAll(root) {
    (root || document).querySelectorAll('.ef-footer').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme Editor: section dirender ulang tiap kali setting diubah */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.ef-footer').forEach(destroy);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloi-products-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProducts = (root = document) => {
      root.querySelectorAll('[data-eloi-products]').forEach((section) => {
        if (section.dataset.eloiProductsReady === 'true') {
          return;
        }

        section.dataset.eloiProductsReady = 'true';

        const tabs = Array.from(section.querySelectorAll('.eloi-products__tab'));
        const cards = Array.from(section.querySelectorAll('[data-product-card]'));
        const category = section.querySelector('[data-filter-category]');
        const brand = section.querySelector('[data-filter-brand]');
        const search = section.querySelector('[data-filter-search]');
        const empty = section.querySelector('[data-empty-state]');
        let activeTab = tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.tab || 'featured';

        const applyFilters = () => {
          const categoryValue = category?.value || 'all';
          const brandValue = brand?.value || 'all';
          const query = (search?.value || '').trim().toLowerCase();
          let visible = 0;

          cards.forEach((card) => {
            const matchesTab = !tabs.length || (card.dataset.tags || '').includes(activeTab);
            const matchesCategory = categoryValue === 'all' || card.dataset.category === categoryValue;
            const matchesBrand = brandValue === 'all' || card.dataset.brand === brandValue;
            const matchesSearch = !query || (card.dataset.title || '').includes(query);
            const shouldShow = matchesTab && matchesCategory && matchesBrand && matchesSearch;

            card.classList.toggle('is-hidden', !shouldShow);

            if (shouldShow) {
              visible += 1;
            }
          });

          if (empty) {
            empty.hidden = visible > 0;
          }
        };

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            activeTab = tab.dataset.tab || 'featured';

            tabs.forEach((item) => item.classList.toggle('is-active', item === tab));
            applyFilters();
          });
        });

        [category, brand, search].forEach((control) => {
          control?.addEventListener('input', applyFilters);
          control?.addEventListener('change', applyFilters);
        });

        applyFilters();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initProducts());
    } else {
      initProducts();
    }

    document.addEventListener('shopify:section:load', (event) => initProducts(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function shuffle(a){ for(var i=a.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=a[i]; a[i]=a[j]; a[j]=t; } return a; }

    function init(marquee){
      if(!marquee || marquee.dataset.psInit) return;
      marquee.dataset.psInit = '1';
      var track = marquee.querySelector('[data-ps-track]');
      if(!track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.ps-card'));
      if(!cards.length) return;

      // acak urutan
      if(marquee.dataset.randomize === 'true'){
        shuffle(cards).forEach(function(c){ track.appendChild(c); });
      }

      marquee.classList.add('ps-fx');

      // auto-scroll: gandakan kartu biar loop mulus
      if(marquee.dataset.autoplay === 'true'){
        cards.forEach(function(c){
          var d = c.cloneNode(true);
          d.setAttribute('aria-hidden','true');
          d.querySelectorAll('a,button').forEach(function(el){ el.setAttribute('tabindex','-1'); });
          track.appendChild(d);
        });
        marquee.classList.add('is-ready');
      }

      bind(track);
    }

    function bind(track){
      track.addEventListener('click', function(e){
        var w = e.target.closest('[data-ps-wish]');
        if(w){ e.preventDefault(); w.classList.toggle('is-on'); return; }
        var b = e.target.closest('[data-ps-add]');
        if(b){ e.preventDefault(); addToCart(b); }
      });
    }

    function cartRoot(){
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    function addToCart(btn){
      if(btn.dataset.loading) return;
      var id = btn.getAttribute('data-variant-id');
      if(!id) return;
      var span = btn.querySelector('span');
      var original = span ? span.textContent : '';
      btn.dataset.loading = '1';
      if(span) span.textContent = 'Menambahkan…';

      fetch(cartRoot() + 'cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items:[{ id: id, quantity: 1 }] })
      })
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){
        btn.classList.add('is-added');
        if(span) span.textContent = 'Ditambahkan \u2713';
        refreshCart();
        document.dispatchEvent(new CustomEvent('ps:cart:added', { bubbles:true }));
      })
      .catch(function(){ if(span) span.textContent = 'Gagal, coba lagi'; })
      .then(function(){
        setTimeout(function(){
          btn.classList.remove('is-added');
          delete btn.dataset.loading;
          if(span) span.textContent = original;
        }, 1600);
      });
    }

    // best-effort update cart count + kasih sinyal ke theme
    function refreshCart(){
      fetch(cartRoot() + 'cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"]').forEach(function(el){
          try { el.textContent = cart.item_count; } catch(e){}
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
      })
      .catch(function(){});
    }

    function run(scope){
      (scope || document).querySelectorAll('[data-ps-marquee]').forEach(init);
    }

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){ run(); });
    } else {
      run();
    }
    // Theme editor: init ulang saat section ditambah/diubah
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
